var map = {
	"./404.svg": 945,
	"./Categories.png": 946,
	"./Edit-menu.svg": 947,
	"./Egg.svg": 948,
	"./Emaier-Header.png": 949,
	"./Qr-4.png": 950,
	"./_duplicate.svg": 951,
	"./_overview.svg": 952,
	"./add-white.svg": 953,
	"./alert.svg": 954,
	"./all_category.svg": 955,
	"./archive.svg": 956,
	"./armchair.svg": 957,
	"./arrow-circle-right.svg": 958,
	"./arrow-left-circle.svg": 959,
	"./arrow-right-circle.svg": 960,
	"./arrow-right.svg": 961,
	"./asc-up-white.svg": 962,
	"./asc.png": 963,
	"./asc.svg": 964,
	"./back-arrow.svg": 965,
	"./barcode-icon.svg": 966,
	"./beverages.svg": 967,
	"./blue-edit-pen.svg": 968,
	"./blue-eye.svg": 969,
	"./box-office.svg": 970,
	"./broken-seat.jpg": 971,
	"./calendar_list.svg": 972,
	"./calender.svg": 355,
	"./chevron-down.svg": 973,
	"./chevron-left.svg": 974,
	"./cinema-mamagement-sidebar.svg": 975,
	"./claendar.svg": 305,
	"./clock-1.svg": 976,
	"./clock.svg": 977,
	"./close-button.svg": 705,
	"./close-white.svg": 708,
	"./close-x.svg": 298,
	"./collapse-up.svg": 978,
	"./collapse.svg": 979,
	"./connection-lost.svg": 353,
	"./copy.svg": 980,
	"./copy_image_icon.png": 981,
	"./delete-red-light.svg": 982,
	"./delete-red.svg": 714,
	"./delete.svg": 690,
	"./deliver-icon.svg": 983,
	"./desc-down-white.svg": 984,
	"./desc.svg": 985,
	"./distributors-sidebar.svg": 986,
	"./download.svg": 987,
	"./dragndrop.svg": 988,
	"./dragndrop2.svg": 989,
	"./duplicate.svg": 990,
	"./duplicateScreen.svg": 991,
	"./e-wallet-icon-black.svg": 992,
	"./edit-pen-blue.svg": 993,
	"./edit-pen-white.svg": 994,
	"./edit-pen.svg": 995,
	"./edit.svg": 996,
	"./email.png": 997,
	"./empty-image.svg": 998,
	"./excel.svg": 999,
	"./external-link.svg": 1000,
	"./eye.svg": 1001,
	"./filter-icon.svg": 1002,
	"./flag.svg": 1003,
	"./fnb-app-order.svg": 1004,
	"./fnb-beverages.svg": 1005,
	"./fnb-brownie.svg": 1006,
	"./fnb-combo.svg": 1007,
	"./fnb-desert.svg": 1008,
	"./fnb-eatables.svg": 1009,
	"./fnb-make-your-combo.svg": 1010,
	"./fnb-popcorn.svg": 1011,
	"./fnbtransactionIcon.svg": 1012,
	"./fullscreen-icon.svg": 715,
	"./funnel.svg": 1013,
	"./globe.svg": 1014,
	"./green-tick.svg": 1015,
	"./grid-view.svg": 1016,
	"./hide-password.svg": 356,
	"./home-icon.svg": 1017,
	"./home.svg": 1018,
	"./icon-black-play.svg": 1019,
	"./icon-dot.svg": 1020,
	"./icon-fnb.svg": 1021,
	"./icon-marketing.svg": 1022,
	"./icon-no-seat.png": 1023,
	"./icon-no-seat.svg": 1024,
	"./icon-option.svg": 1025,
	"./icon-poin-of-sale.svg": 1026,
	"./icon-recliner.svg": 1027,
	"./icon-report.svg": 1028,
	"./icon-sofa-dark-1.svg": 1029,
	"./icon-sofa-dark.png": 1030,
	"./icon-sofa-dark.svg": 1031,
	"./icon-sofa.svg": 1032,
	"./importfile.svg": 1033,
	"./info.svg": 709,
	"./info2.svg": 1034,
	"./keyboard-icon.svg": 1035,
	"./kitchen_display.svg": 1036,
	"./language-icon.svg": 299,
	"./left-caret.svg": 1037,
	"./link.svg": 1038,
	"./list-view.svg": 1039,
	"./loading.svg": 357,
	"./lock.svg": 1040,
	"./login-password.png": 358,
	"./login-user.png": 359,
	"./logout.svg": 710,
	"./masters-sidebar.svg": 1041,
	"./merchandise.svg": 1042,
	"./minus.svg": 1043,
	"./movie-pass-svg.svg": 699,
	"./movie-rolling.svg": 1044,
	"./mulitSchedule.svg": 1045,
	"./multicurrency.svg": 1046,
	"./multifnb.svg": 1047,
	"./nav-plus.svg": 1048,
	"./new_filter_icon.svg": 1049,
	"./no-image.svg": 1050,
	"./no-schedule.svg": 133,
	"./non-veg-mark.png": 1051,
	"./non-veg-mark.svg": 1052,
	"./notification.svg": 1053,
	"./open-link-blue.svg": 1054,
	"./openPlanned.svg": 1055,
	"./overview.svg": 1056,
	"./overview2.svg": 1057,
	"./pdf-icon.svg": 1058,
	"./pdf.svg": 1059,
	"./pickup-ticket-icon.svg": 1060,
	"./pickupfnb.svg": 1061,
	"./play.svg": 1062,
	"./plus.svg": 1063,
	"./pointofsale-1.svg": 1064,
	"./pointofsale-2.svg": 1065,
	"./pointofsale.png": 1066,
	"./portfolio.svg": 1067,
	"./pos-fnb-no-itmes.svg": 701,
	"./pos-refresh.svg": 1068,
	"./primary/chevron-down.svg": 1069,
	"./primary/download.svg": 1070,
	"./primary/edit.svg": 1071,
	"./primary/filter.svg": 1072,
	"./primary/printer.svg": 1073,
	"./print-icon.svg": 1074,
	"./print.svg": 1075,
	"./question.svg": 1076,
	"./question1.svg": 1077,
	"./question2.svg": 716,
	"./question3.svg": 1078,
	"./recliner-1.svg": 1079,
	"./recliner.png": 1080,
	"./refund-icon.svg": 1081,
	"./reload-icon-pos.svg": 1082,
	"./reload-icon.svg": 1083,
	"./restore.svg": 1084,
	"./right-caret.svg": 1085,
	"./role-management-sidebar.svg": 1086,
	"./save.svg": 1087,
	"./schedule-icon.svg": 1088,
	"./school-calendar.svg": 1089,
	"./search-global-white.svg": 1090,
	"./search-global.svg": 1091,
	"./search.svg": 717,
	"./searchIcon.svg": 1092,
	"./seat-icon-2.svg": 1093,
	"./seat-icon.svg": 1094,
	"./seat-icons/3-wheelChair.png": 1095,
	"./seat-icons/block_seat_new.png": 1096,
	"./seat-icons/broken-seat-1.svg": 1097,
	"./seat-icons/broken-seat-2.svg": 1098,
	"./select-food.png": 718,
	"./settings.svg": 1099,
	"./show-password.svg": 360,
	"./slider-triangle.svg": 1100,
	"./snack.svg": 711,
	"./sort.svg": 1101,
	"./star-empty.svg": 1102,
	"./star-fill.svg": 1103,
	"./success-tick.svg": 1104,
	"./suitcase.svg": 1105,
	"./swap.svg": 1106,
	"./tick-green-item.svg": 719,
	"./tick-green.svg": 1107,
	"./ticket-icon.svg": 1108,
	"./trash.svg": 1109,
	"./unpaid-reservation.svg": 693,
	"./updown-white.svg": 1110,
	"./updown.svg": 1111,
	"./user-attribute.svg": 1112,
	"./user-attributes.svg": 1113,
	"./user-female.svg": 1114,
	"./user-male-white.svg": 1115,
	"./user-male.svg": 1116,
	"./user-profile.svg": 1117,
	"./userProfile.png": 1118,
	"./veg-food-mark-white.png": 1119,
	"./veg-foog-mark-trans.png": 1120,
	"./view.png": 1121,
	"./view.svg": 1122
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 944;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 944
// module chunks = 35